import dayjs from "dayjs";
import "dayjs/locale/ru";
import relativeTime from "dayjs/plugin/relativeTime";
import isToday from "dayjs/plugin/isToday";
import isTomorrow from "dayjs/plugin/isTomorrow";

dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(isTomorrow);
dayjs.locale("ru");

/** «Сегодня 19:00» / «Завтра 12:30» / «22 апр, 14:00» */
export function formatEventDate(iso: string): string {
  const d = dayjs(iso);
  const time = d.format("HH:mm");
  if (d.isToday()) return `Сегодня ${time}`;
  if (d.isTomorrow()) return `Завтра ${time}`;
  return d.format(`D MMM, ${time}`);
}

/** «5 дн. назад» / «только что» */
export function formatRelative(iso: string): string {
  const d = dayjs(iso);
  const diffMin = dayjs().diff(d, "minute");
  if (diffMin < 1) return "только что";
  return d.fromNow();
}

export function formatPrice(rubles: number): string {
  if (rubles === 0) return "бесплатно";
  return `${rubles.toLocaleString("ru-RU")} ₽`;
}

export function formatRatingDelta(delta: number): string {
  if (delta === 0) return "0";
  return delta > 0 ? `+${delta}` : `${delta}`;
}
